<template>
    <CodiceFeanorView tool-module="regex" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
